import React, { useEffect, useCallback, useMemo, useState } from 'react';
import {
  FieldCheckBox,
  FieldDatepicker,
  FieldInput,
  FieldTextArea,
  FormCol,
  FormCol2,
  FormCol6,
  FormRow,
} from 'motion-components';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { useTranslation } from 'react-i18next';
import { dateField, isActiveField } from 'shared-pages/common/form-helpfunc';
import { Col, Row } from 'react-bootstrap';
import { FileRepoField } from 'shared-pages/components/filerepo-field';
import { FileRepoImage } from 'shared-pages/components/filerepo-image';
import {
  FieldSelectContributionPeriodGroups,
  FieldSelectContributorGroups,
} from '../../components';

export const FormFields = ({ isNew, updateRecord, refetch, data }) => {
  //
  const frmkCntx = useFormikContext();
  const { values } = frmkCntx;
  const { authStore, appStore } = useRootStore();

  const { handleGraphqlError } = useHandleError('PiBaseFormFields');
  const { t } = useTranslation();

  function calcUserCanEdit() {
    const canEdit = appStore.isPlatformOwner || isNew;
    const canEditReasoning = '';
    return { canEdit, canEditReasoning };
  }
  const { canEdit, canEditReasoning } = calcUserCanEdit();

  return (
    <>
      <FormRow>
        {/* Line 1 */}
        <FieldInput
          required={true}
          disabled={!canEdit}
          as={FormCol}
          label="Επωνυμία"
          name="name"
          placeholder="- όνομα επιχείρισης -"
        />
        <FieldInput
          disabled={!canEdit}
          as={FormCol}
          label="Υπεύθυνος"
          name="contactPerson"
          placeholder=""
        />
        <FieldInput
          required={true}
          disabled={!canEdit}
          as={FormCol}
          label="Email"
          name="email"
          placeholder=""
        />
      </FormRow>
      <FormRow>
        {/* Line 2 */}
        <FieldInput
          required={true}
          disabled={!canEdit}
          as={FormCol}
          label="Διεύθυνση"
          name="addressLine1"
          placeholder="- γράψτε την διεύθυνση -"
        />
        <FieldInput
          required={true}
          disabled={!canEdit}
          as={FormCol}
          label="Τηλέφωνο 1"
          name="phoneNumber1"
          placeholder=""
        />
        <FieldInput
          disabled={!canEdit}
          as={FormCol}
          label="ΑΜΠ"
          name="producerRegNum"
          placeholder=""
        />
      </FormRow>
      <FormRow>
        {/* Line 3 */}
        <FieldInput
          disabled={!canEdit}
          as={FormCol}
          label="Διεύθυνση - 2η γραμμή"
          name="addressLine2"
          placeholder="- γράψτε την διεύθυνση -"
        />
        <FieldInput
          disabled={!canEdit}
          as={FormCol}
          label="Τηλέφωνο 2"
          name="phoneNumber2"
          placeholder=""
        />
        <FieldSelectContributionPeriodGroups as={FormCol}></FieldSelectContributionPeriodGroups>
      </FormRow>
      <FormRow>
        {/* Line 4 */}
        <FieldInput
          required={true}
          disabled={!canEdit}
          as={FormCol}
          label="Περιοχή"
          name="addressArea"
          placeholder="- γράψτε την περιοχή -"
        />
        <FieldInput
          disabled={!canEdit}
          as={FormCol}
          label="Κινητό"
          name="mobileNumber1"
          placeholder=""
        />
        <FieldSelectContributorGroups as={FormCol}></FieldSelectContributorGroups>
      </FormRow>
      <FormRow>
        {/* Line 5 */}
        <FieldInput
          required={true}
          disabled={!canEdit}
          as={FormCol}
          label="Πόλη"
          name="addressCity"
          placeholder="- γράψτε την πόλη -"
        />
        <FieldInput
          required={true}
          disabled={!canEdit}
          as={FormCol}
          label="Α.Φ.Μ."
          name="vatNumber"
          placeholder=""
        />
        <Col>
          <FieldCheckBox disabled={!canEdit} as={"div"} label="Ενεργή Εγγραφή" name="isActive" />
        </Col>
      </FormRow>
      <FormRow>
        {/* Line 6 */}
        <FieldInput
          required={true}
          disabled={!canEdit}
          as={FormCol}
          label="Τ.Κ."
          name="postalCode"
          placeholder="ταχυδρομικός κωδικός -"
        />
        <FieldInput
          required={true}
          disabled={!canEdit}
          as={FormCol}
          label="Δ.Ο.Υ."
          name="taxOffice"
          placeholder=""
        />
      </FormRow>
    </>
  );
};

const FormCol12 = (props) => (
  <Col sm={12} lg={12} xl={12} {...props}>
    {props.children}
  </Col>
);

